import { Col } from 'components'

export default function FormCol({children, ...props}) {
    return (
        <Col xs={12} sm={6} md={6} {...props}>
            {children}
        </Col>
    )
}
